import PrimaryButton from '../button/PrimaryButton';
import { useCrashReport } from '../../context/CrashReportProvider';
import pikkoThankBox from '../../styles/img/reports/pikkoThankBox.svg';

const CrashReportModalSuccess = ({ title ="Merci beaucoup !", description="Toute l’équipe est sur le coup pour me sauver !", buttonLabel="Reprendre où j'en étais" }) => {
  const { resumeFromSuccess } = useCrashReport();

  return (
    <div className="flex fixed inset-0 flex-col items-center justify-center h-full w-full bg-gradient1 animate-success-appear px-6 pb-10 overflow-y-auto overflow-x-hidden">
      <div className="flex flex-col items-center justify-center">
        <img src={pikkoThankBox} alt="Pikko Thank Box" className="w-[300px] h-[300px]" />
        <div className="flex flex-col items-center justify-center bg-white relative -translate-y-14 rounded-[20px] shadow-[0px_0px_30px_0px_rgba(0,0,0,0.1)] p-6 mt-6 min-h-[100px] w-full max-w-[250px]">
          <h1 className="geomanistMedium text-3xl font-light text-zinc-900 text-center mb-4">
            {title}
          </h1>
          <p className="text-zinc-900 text-center text-2xl geomanistRegular mb-2">
            {description}
          </p>
        </div>
      </div>

      <div className="w-full animate-button-appear mb-20">
        <PrimaryButton
          onClick={resumeFromSuccess}
          label={buttonLabel}
          className="w-[95%] mx-auto !text-white !shadow-[0px_8px_0px_0px_rgba(100,100,100)]"
          style={{
            background: '#0E0B26',
          }}
        />
      </div>

    </div>
  );
};

export default CrashReportModalSuccess;